module.exports = __webpack_public_path__ + "static/IPA Logo (10)-07ce84409b198362dfb26f4748cfb60d.png";